import React, { createContext, useContext, useMemo, useState } from 'react';
import { FeedType } from './ultraFeedTypes';

interface UltraFeedContextType {
  openInNewTab: boolean;
  feedType: FeedType;
  showScoreBreakdown: boolean;
  setShowScoreBreakdown: (show: boolean) => void;
}

const UltraFeedContext = createContext<UltraFeedContextType | undefined>(undefined);

export const UltraFeedContextProvider = ({ 
  children, 
  openInNewTab = false,
  feedType = 'ultraFeed'
}: { 
  children: React.ReactNode;
  openInNewTab?: boolean;
  feedType?: FeedType;
}) => {
  const [showScoreBreakdown, setShowScoreBreakdown] = useState(false);
  const context = useMemo(() => ({ openInNewTab, feedType, showScoreBreakdown, setShowScoreBreakdown }), [openInNewTab, feedType, showScoreBreakdown]);
  
  return (
    <UltraFeedContext.Provider value={context}>
      {children}
    </UltraFeedContext.Provider>
  );
};

export const useUltraFeedContext = () => {
  const context = useContext(UltraFeedContext);
  return context ?? { openInNewTab: false, feedType: 'ultraFeed', showScoreBreakdown: false, setShowScoreBreakdown: () => {} };
};

